import { Pipe, PipeTransform } from '@angular/core'
import { FirebaseService } from '../services/firebase.service';

@Pipe({ name: 'loadImage', pure: true })
export class LoadImagePipe implements PipeTransform {

    constructor(
        private _firebaseService: FirebaseService
    ){}

    async transform(value: string) {
        console.log("pipe called -----------------------", value)
        if(value != null)
            return await this._firebaseService.getDownloadUrl(value).toPromise()
    }
}